/*
Hinge Plates

  --thickness <float::enum> | millimeters | [0, 3, 6, 9, 18]
  --wedges <bool> | checkbox
*/
import filters from './filters'
import headers from './headers'
import form from './form'

const name = 'Hinge Plates'
const id = 'zUlrNLfRH0d7G8R6A2jG'

export default {
  name,
  id,
  filters,
  headers,
  form
}
